<template>
  <aw-error-page-content :error="error" />
</template>
<script setup>
  import AwErrorPageContent from '~~/common/components/AwErrorPageContent.vue';

  defineOptions({
    name: 'ShopErrorPage',
  });
  defineProps({
    error: {
      type: Object,
      default: () => ({}),
    },
  });
</script>
